/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  FinancialPlanSmallTotalDto,
  FinancialPlanSmallTotalDtoFromJSON,
  FinancialPlanSmallTotalDtoFromJSONTyped,
  FinancialPlanSmallTotalDtoToJSON,
} from "./FinancialPlanSmallTotalDto";
import {
  FinancialPlanStatus,
  FinancialPlanStatusFromJSON,
  FinancialPlanStatusFromJSONTyped,
  FinancialPlanStatusToJSON,
} from "./FinancialPlanStatus";

/**
 *
 * @export
 * @interface MonthPlanSimpleFinancialPlanDto
 */
export interface MonthPlanSimpleFinancialPlanDto {
  /**
   *
   * @type {FinancialPlanStatus}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  status: FinancialPlanStatus;
  /**
   *
   * @type {string}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  monthPlanId: string;
  /**
   *
   * @type {number}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  monthWeekPosition: number;
  /**
   *
   * @type {Date}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  from: Date;
  /**
   *
   * @type {Date}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  to: Date;
  /**
   *
   * @type {boolean}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  closesWeek: boolean;
  /**
   *
   * @type {number}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  month: number;
  /**
   *
   * @type {number}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  year: number;
  /**
   *
   * @type {FinancialPlanSmallTotalDto}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  plan: FinancialPlanSmallTotalDto;
  /**
   *
   * @type {FinancialPlanSmallTotalDto}
   * @memberof MonthPlanSimpleFinancialPlanDto
   */
  fact: FinancialPlanSmallTotalDto;
}

export function MonthPlanSimpleFinancialPlanDtoFromJSON(json: any): MonthPlanSimpleFinancialPlanDto {
  return MonthPlanSimpleFinancialPlanDtoFromJSONTyped(json, false);
}

export function MonthPlanSimpleFinancialPlanDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanSimpleFinancialPlanDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    status: FinancialPlanStatusFromJSON(json["status"]),
    id: json["id"],
    monthPlanId: json["monthPlanId"],
    monthWeekPosition: json["monthWeekPosition"],
    createdAt: new Date(json["createdAt"]),
    from: new Date(json["from"]),
    to: new Date(json["to"]),
    closesWeek: json["closesWeek"],
    month: json["month"],
    year: json["year"],
    plan: FinancialPlanSmallTotalDtoFromJSON(json["plan"]),
    fact: FinancialPlanSmallTotalDtoFromJSON(json["fact"]),
  };
}

export function MonthPlanSimpleFinancialPlanDtoToJSON(value?: MonthPlanSimpleFinancialPlanDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    status: FinancialPlanStatusToJSON(value.status),
    id: value.id,
    monthPlanId: value.monthPlanId,
    monthWeekPosition: value.monthWeekPosition,
    createdAt: value.createdAt.toISOString(),
    from: value.from.toISOString(),
    to: value.to.toISOString(),
    closesWeek: value.closesWeek,
    month: value.month,
    year: value.year,
    plan: FinancialPlanSmallTotalDtoToJSON(value.plan),
    fact: FinancialPlanSmallTotalDtoToJSON(value.fact),
  };
}
